

    import React,{Component} from 'react';
	
	// import {BrowserRouter,Route,Link} from 'react-router-dom';
	 import axios from "axios";
	
	 
	class UpdatesIsssuesComponent extends Component{
	
		constructor(props)
		{
			super(props)
			
			this.state = {
				issueName: null,
				issueState: null,
				issueProgLang: null,
				id:null,
				loading:false
			}

            this.handleProgLang = this.handleProgLang.bind(this);
			this.handleIssueName = this.handleIssueName.bind(this);
			this.handleIssueState = this.handleIssueState.bind(this);
			this.handleSaveIssue = this.handleSaveIssue.bind(this);

		}
	

        async componentDidMount()
        {
            //get details from url
            this.setState({id: this.props.match.params.id});
            this.setState({issueState: this.props.match.params.state});
            this.setState({issueName: this.props.match.params.issueName});
            this.setState({issueProgLang: this.props.match.params.progLang});
       
           
        
        }

      async componentDidUpdate()
        {
            if((this.state.id === null) || (this.state.id === "") || (this.state.issueProgLang === null) || (this.state.issueProgLang === "") || (this.state.issueName === null) || (this.state.issueName === "") || (this.state.issueState === null) || (this.state.issueState === ""))
			{
                alert("Bad request!");
                this.props.history.push("/gitsearch/");
            }

            try
              {
                    //get user access token
                    let token = localStorage.getItem("token");
                    
                    if((token === "noToken") || (token === null))
                    {
                    alert("Ilegal page view");
                    this.props.history.push("/gitsearch/");
                    }
 
                    let userDataResponse = await axios({
                    method: "get",
                    url: "http://mofehintolumumuni.com/gitserver/api/users/profile",
                    headers: {"Authorization": "Bearer "+token}
                    });
 
                    let requestStatus = userDataResponse.data.status;
                    //let payload = userDataResponse.data.data
 
                    if(requestStatus !== "success")
                    {
 
                     this.props.history.push("/gitsearch/");
                
                    }
                  
 
                }
                catch(error)
                {
                 this.props.history.push("/gitsearch/");
                }
        }

      

        handleIssueName(e)
		{
			this.setState({issueName:e.target.value});
		}
		handleIssueState(e)
		{
			this.setState({issueState:e.target.value});
		}
		
		handleProgLang(e)
		{
			this.setState({issueProgLang:e.target.value});
		}
		
		async handleSaveIssue(e)
		{
			e.preventDefault();

			//get user access token
			let token = localStorage.getItem("token");

			this.setState({loading:true});

			if((this.state.issueProgLang !== null) && (this.state.issueProgLang !== "") && (this.state.issueName !== null) && (this.state.issueName !== "") && (this.state.issueState !== null) && (this.state.issueState !== ""))
			{
				//make axios call
				try{

					let response = await axios({
						method: "put",
						url: "http://mofehintolumumuni.com/gitserver/api/users/preference/github/issueSearch/edit",
						"data":{
                            id: this.state.id,
						  issue: this.state.issueName,
						language: this.state.issueProgLang,
						state: this.state.issueState
						},
						headers: {"Authorization": "Bearer "+token}
					});

					let status = response.data.status;
					let message = response.data.data;

						if(status === "success")
						{
							this.setState({loading:false});
							alert("Github Issue data saved successfully!");
						
						}
						else
						{
							this.setState({loading:false});
							alert(`Github Issue data not saved successfully! ${message}`);
						}
				}
				catch(error)
				{
					this.setState({loading:false});
					alert("Github Issue not saved successfully!");
				}
			}
			else
			{
				this.setState({loading:false});
				alert("Fill Issue form properly before submitting!");
			}

		}



	render()
	{
	return(
	
		<React.Fragment>
		<section>
		<div id="page-wrapper" className="sign-in-wrapper">
				<div className="graphs">
					<div className="sign-in-form">
						<div className="sign-in-form-top">
							<h1 >UPDATE ISSUES <i className="fa fa-sign-in custom"></i></h1>

							{(this.state.loading) ? <h3>Loading data from Server <i className="fa fa-cogs" ></i> </h3> : null}
							{(this.state.issueName !== null) ?<p>Issue: {this.state.issueName}</p> : null }
							{(this.state.issueProgLang !== null) ?<p>Language: {this.state.issueProgLang}</p> : null }
							{(this.state.issueState !== null) ?<p>State: {this.state.issueState}</p> : null }

						</div>
						<div className="signin">
						
							<form onSubmit={this.handleSaveIssue}>
							<div className="log-input">
								<div className="log-input-left">
								   <input type="text" name="issue" className="user" placeholder="Enter Issue" onChange={this.handleIssueName} />
								</div>
								
								<div className="clearfix"> </div>
							</div>
                            <div className="log-input">
                                <div className="log-input-left">
									<select name="selector1"  className="form-control1" onChange={this.handleProgLang}>
									<option value="">CHOOSE LANGUAGE</option>
									<option value="php">PHP</option>
									<option values="javascript">JAVASCRIPT</option>
									<option value="c#">C-SHARP</option>
									<option value="python">PYTHON</option>
									<option value="dart">DART</option>
									<option value="delphi">Delphi</option>
									<option value="elixir">ELIXIR</option>
									<option value="erlang">ERLANG</option>
									<option value="hack">HACK</option>
									<option value="kotlin">KOTLIN</option>
									<option value="lua">LUA</option>
									<option value="rust">RUST</option>
									<option value="typescript">TYPESCRIPT</option>
									<option value="unrealscript">UNREALSCRIPT</option>
									<option value="C">C</option>
									<option value="C++">C++</option>
									<option value="GO">GO</option>
									<option value="ruby">RUBY</option>
									<option value="java">JAVA</option>
									<option value="solidity">SOLIDITY</option>
									<option value="swift">SWIFT</option>
									<option value="r">R</option>
									<option value="objective-c">OBJECTIVE-C</option>
									<option value="sql">SQL</option>
									<option value="haskel">HASKEL</option>
									<option value="powershell">POWERSHELL</option>
									<option value="fortran">FORTRAN</option>
									</select>
                                    </div>
							</div>
                            <br></br>
                            <br></br>
                            <br></br>
                            <br></br>
                            <div className="log-input">
                                <div className="log-input-left">
						<select name="selector1"  className="form-control1" onChange={this.handleIssueState}>
							
								<option value="open">OPEN</option>
								<option value="closed">CLOSED</option>
								
				
						</select>
                                    </div>
							</div>
                            <br></br>
                        <br></br>
						<br></br>
							<input id="logi" type="submit" name="send" value="UPDATE"  />
						</form>	 
                        <br></br>

						
						
                        <br></br>
						
						</div>
					
					</div>
				</div>
			</div>
			</section>
</React.Fragment>

	);
	}


    }
    



    export default UpdatesIsssuesComponent;


